import { Attributes, Misc, ValueObject } from "@singularsystems/neo-core";
export default class BaseCheckQueryConfigCommand extends ValueObject {

    public staticServiceProviderFileGroupingId: number = 0;

    public checkQueryId: number = 0;
    public runForStaticServiceProviderInd: boolean = false;

    public checkQueryImportProcessStepId: number = 0;

    public activeInd: boolean = false;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public nextExecutionDateTime: Date | null = null;

    public nextExecutionDateString: string = "";

    public dataTableIsInBodyInd: boolean = false;

    public emailAddresses: string = "";

    public emailAddressesList: string[] = [];

    public addResultInd: boolean = false;

    @Attributes.Decimal()
    public minVariance: number = 0;

    @Attributes.Decimal()
    public maxVariance: number = 0;

    public runFrequency: number | null = null;

    public importProcessStepId: number = 0;
}